import '../_assets/VideoPlayerIcons.B8gMK1do.css';var r = "VideoPlayerIcons_circle__1rffr850", e = "VideoPlayerIcons_hoverWhiteToBlack__1rffr852";
export {
  r as c,
  e as h
};
